const MOBILE_MAX_WIDTH = 599
const TABLET_MAX_WIDTH = 1024
const WIDESCREEN_DOWN = 1199

export const DeviceMixin = {
  data() {
    return {
      vssWidth: null,
      vssHeight: null,
      vssClientHeight: null
    }
  },
  methods: {
    handleResize() {
      this.vssWidth = this.getScreenWidth()
      this.vssHeight = this.getScreenHeight()
    },
    getScreenWidth() {
      return (
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      )
    },
    getScreenHeight() {
      return (
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
      )
    },
    clientHeightResize() {
      this.vssClientHeight = this.getClientHeight()
    },
    getClientHeight() {
      return visualViewport.height
    }
  },
  computed: {
    isMobile() {
      return this.vssWidth <= MOBILE_MAX_WIDTH
    },
    isTablet() {
      return this.vssWidth <= TABLET_MAX_WIDTH
    },
    isWidescreenDown() {
      return this.vssWidth <= WIDESCREEN_DOWN
    },
    clientHeight() {
      return this.getClientHeight()
    },
    hasVisualViewport() {
      return typeof visualViewport !== 'undefined'
    }
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    if (this.hasVisualViewport) {
      visualViewport.addEventListener('resize', this.clientHeightResize)
    }
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize)
    if (this.hasVisualViewport) {
      visualViewport.removeEventListener('resize', this.clientHeightResize)
    }
  }
}
